import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

import { MENU_WIDTH } from './const';
const TEXT_LINE_HEIGHT = 20;
const TEXT_MIN_LINES = 2;
export default makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      background: 'white',
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
      borderBottom: theme.shape.borderGray80,
      '&:focus-within': {
        border: '1px solid ' + COLORS.primary.default,
        borderRadius: theme.shape.borderRadius,
      },
    },

    tooltip: {
      maxWidth: 'none',
      padding: theme.spacing(1),
    },

    messagingBankTooltip: {
      maxWidth: 380,
    },

    improveButton: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',

      '&:disabled': {
        '& svg': {
          opacity: 0.4,
        },
      },
    },
    spinner: {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
      }),
    },

    startIcon: {
      marginRight: theme.spacing(0.5),
    },
    improveStartIcon: {
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(16) + ' !important',
    },
    saveStartIcon: {
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(16) + ' !important',
    },
    saveStartDisabled: {
      color: COLORS.gray.gray50,
      fontSize: theme.typography.pxToRem(16) + ' !important',
    },
    menuPaper: {
      //style for the subheader
      '& > * > *:first-child': {
        minHeight: 'auto',
      },
    },

    menuWrapper: {
      maxHeight: 400,
      width: 'fit-content',
      maxWidth: MENU_WIDTH,
      minWidth: MENU_WIDTH,
    },
    menuItem: {
      minHeight: 40,
    },
    listItemMain: {
      justifyContent: 'space-between',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
    listItemMainNoSpace: {
      display: 'flex',
      alignItems: 'center',
    },
    buttonIcon: {
      height: theme.spacing(2),
      width: theme.spacing(2),
      color: COLORS.gray.gray40,
      marginRight: theme.spacing(1),
    },
    chevronIcon: {
      height: theme.spacing(2),
      width: theme.spacing(2),
      color: COLORS.gray.gray40,
    },
    subMenu: {
      maxHeight: 319,
      width: 'fit-content',
      minWidth: 280,
      maxWidth: 320,
    },

    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.black,
      fontWeight: theme.typography.fontWeightMedium,
    },
    body: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(22),
      color: COLORS.gray.gray40,
      whiteSpace: 'pre-wrap',
      display: '-webkit-box',
      '-webkit-line-clamp': TEXT_MIN_LINES,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      maxHeight: TEXT_LINE_HEIGHT * TEXT_MIN_LINES,
    },
    subHeader: {
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1.25),
      paddingLeft: theme.spacing(1),
    },
    selected: {},
    emptyState: {
      padding: theme.spacing(0, 2, 0),
      minHeight: 20,
      backgroundColor: 'unset',
      cursor: 'default',
      '&:hover, &$selected': {
        backgroundColor: 'unset',
      },
      '& > p': {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(20),
        color: COLORS.neutral.mediumGray,
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      padding: theme.spacing(0, 0, 0, 1),
      backgroundColor: 'unset !important',
      minHeight: 20,
      cursor: 'default',
      '&:hover, &$selected': {
        backgroundColor: 'unset',
      },
      '&  p': {
        color: COLORS.gray.gray40,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(14),
      },
    },

    createButton: {
      backgroundColor: 'unset',
      cursor: 'pointer',
      borderRadius: 0,
      marginBottom: theme.spacing(1.25),
      paddingTop: 0,
      borderBottom: theme.shape.borderGray70,
      '&:hover, &$selected': {
        backgroundColor: 'unset',
        textDecoration: 'underline',
      },

      '& > p': {
        marginBottom: theme.spacing(0.5),
        color: COLORS.primary.active,
        '&:hover, &$selected': {
          textDecoration: 'underline',
        },
      },
      '&:last-child': {
        border: 'none',
        marginBottom: 0,
        paddingBottom: 0,
      },
    },
    menuIcon: {
      display: 'flex',
      width: '100%',
    },
    search: {
      maxHeight: 40,
      marginBottom: theme.spacing(1),
    },
    showMoreAssets: {
      color: COLORS.primary.default,
      paddingLeft: theme.spacing(2),
      cursor: 'pointer',
      justifyContent: 'start',
    },
    itemContent: {
      maxWidth: '100%',
    },
    assetIcon: {
      color: COLORS.gray.gray30,
    },

    noTransition: {
      transition: 'none',
    },
    resourceItem: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' },
    promptFooter: { padding: theme.spacing(0, 2) },
  }),
  { name: 'PromptInstructions' }
);
